import React, { useEffect, useMemo, useState } from 'react';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { ThemeProvider, createTheme } from '@mui/material/styles';
//------------------------------------------------------------
//const config.ipAddress = '127.0.0.1'; // IP for developement local
//const config.ipAddress = '192.168.1.200'; // IP for deployment IIS
//------------------------------------------------------------

const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  // Create a dark theme
const darkTheme = createTheme({
    palette: {
      type: 'dark', // Use dark mode
      primary: {
        main: '#2196f3', // Change the primary color
      },
      secondary: {
        main: '#f50057', // Change the secondary color
      },
      background: {
        default: '#FF0266', // Change the default background color
        paper: '#121212', // Change the paper (container) background color
      },
      text: {
        primary: '#FFFFFF', // Add text color for dark theme
        secondary: '#A0A0A0',
    },
    },          
    
  });

  // Create a light theme
const lightTheme = createTheme({
    palette: {
      type: 'light', // Use light mode
      primary: {
        main: '#2196f3', // Change the primary color
      },
      secondary: {
        main: '#f50057', // Change the secondary color
      },
      background: {
        default: '#ffffff', // Change the default background color
        paper: '#ffffff', // Change the paper (container) background color
      },
    },
    
  });
  
  let selectedTheme;

  

const Cal = ({ theme }) => {
const [locationData, setLocationData] = useState([]);

useEffect(() => {
fetchData();
}, []);

const fetchData = async () => {
try {
    const response = await fetch(`/api/`);
    const result = await response.json();
    setLocationData(Array.isArray(result.locationTable) ? result.locationTable : []);
 
} catch (error) {
    console.error('Error fetching data:', error);
}
};

const totalSites = useMemo(() => locationData.length, [locationData]);

const totalSitesWithSupport = useMemo(
  () => locationData.filter((item) => [2, 3].includes(Number(item.SupportStatus))).length,
  [locationData]
);


const today = new Date();
const month = months[today.getMonth()]; //months[currentMonthIndex];
const year = today.getFullYear();
const date = today.getDate();

selectedTheme = lightTheme;



  
    if (theme === 'dark')
    {
        selectedTheme = darkTheme;
    }
  return (
    <>
    <ThemeProvider theme={selectedTheme}>
    <Card sx={{ height: '258px' }}>
      <CardContent>
      <Typography variant="overline" sx={{ fontSize: 17 }} component="div">
        <u>DASHBOARD</u>
      </Typography>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          Date
        </Typography>
        <Typography variant="h5" component="div">
          {date} {month}, {year}
        </Typography>
        <Typography sx={{ mb: 1.5 }} color="text.secondary">
          
        </Typography>
        <Typography variant="button">
        Total Sites: {totalSites}
        <br />
        </Typography>
        <Typography variant="button">
        Total Sites With Support: {totalSitesWithSupport}
        <br />
        </Typography>
      </CardContent> 
     </Card>
<br></br>
  
     </ThemeProvider>
    </>
  )
}

export default Cal
